<template>
  <div class="car_list_item" @click="search">
    <div class="image_box">
      <img :src="car_data['car_photo']['photo'][0]" @error="imageLoadOnError" />
    </div>
    <div class="info_box">
      <div class="first_row">
        <a
          ><h2>{{ car_data["make"] }} {{ car_data["model"] }}</h2></a
        >
        <div class="flex">
          <a
            v-bind:href="'https://www.copart.com/lot/' + car_data['lot_number']"
            target="_blank"
            v-if="car_data['auction_name'] == 'COPART'"
            class="auction_name"
            >{{ car_data["auction_name"] }}</a
          >
          <a v-if="car_data['auction_name'] == 'IAAI'" class="auction_name">{{
            car_data["auction_name"]
          }}</a>
          <p class="vin">{{ car_data["vin"] }}</p>
          <!-- <a :href="" class="lot">{{ car_data["lot"] }}</p> -->
        </div>
      </div>
      <div class="info-boxes">
        <div
          v-if="car_data['engine_type'] != null"
          class="info-box"
          v-for="box in car_data['engine_type'].split(',')"
        >
          {{ box }}
        </div>
        <div class="info-box" v-if="car_data['fuel'] != null">
          {{ car_data["fuel"].toUpperCase() }}
        </div>
        <div class="info-box" v-if="car_data['car_keys'] == 'yes'">
          <img
            src="../assets/icons/key.svg"
            class="icon"
            @click="selected.auction_name = ''"
          />
        </div>
      </div>
      <div class="flex">
        <div class="info-details">
          <span>
            Przebieg<br />
            <strong>
              {{
                Math.round(
                  Number(car_data["odometer"]) * 1.6093
                ).toLocaleString()
              }}
              km ({{
                Number(car_data["odometer"]).toLocaleString()
              }}
              mi)</strong
            ></span
          >

          <span
            >Uszkodzenie <br /><strong>{{
              car_data["primary_damage"]
            }}</strong></span
          >
          <span
            >Lokalizacja <br /><strong>{{ car_data["location"] }}</strong></span
          >
          <span
            >Dokumenty<br /><strong>{{ car_data["doc_type"] }} </strong></span
          ><br />
        </div>
        <div class="auction-info">
          <span class="time_until" v-if="car_data['active_bidding'][0] != null">
            <img
              src="../assets/icons/clock.svg"
              class="icon"
              @click="selected.auction_name = ''"
            />{{ timeUntil(car_data["active_bidding"][0]["sale_date"]) }}
          </span>
          <span class="date" v-if="car_data['active_bidding'][0] != null">
            <img
              src="../assets/icons/calandar.svg"
              class="icon"
              @click="selected.auction_name = ''"
            />{{ formatDate(car_data["active_bidding"][0]["sale_date"]) }}
          </span>
          <div class="offer" v-if="car_data['active_bidding'][0] != null">
            Aktualna Oferta

            <span> ${{ car_data["active_bidding"][0]["current_bid"] }}</span>
          </div>
        </div>
      </div>
      <!-- <br v-if="car_data['buy_now_car'] != null" />
      <span v-if="car_data['buy_now_car'] != null">Możliwy szybki zakup</span>
      <br v-if="car_data['buy_now_car'] != null" />
      <span class="time_until" v-if="car_data['active_bidding'][0] != null"
        >{{ timeUntil(car_data["active_bidding"][0]["sale_date"]) }}
      </span>
      <div class="info_price" v-if="car_data['active_bidding'][0] != null">
        Cena na aukcji:

        <span> ${{ car_data["active_bidding"][0]["current_bid"] }}</span>
      </div> -->
    </div>
  </div>
</template>


<script>
export default {
  name: "SearchBar",
  props: ["car_data"],
  data() {},
  methods: {
    imageLoadOnError(e) {
      e.target.src =
        "https://ralfvanveen.com/wp-content/uploads/2021/06/Placeholder-_-Glossary.svg";
    },
    search() {
      window.top.location.href = `https://amerykacars.pl/wyniki-wyszukiwania/?lot_number=${this.car_data["lot_number"]}`;
    },

    formatDate(unixTimestamp) {
      // Przekształcenie timestampu w milisekundy
      const date = new Date(unixTimestamp * 1);

      // Uzyskanie elementów daty
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Miesiące są od 0 do 11, więc dodajemy 1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // Formatowanie daty
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    timeUntil(unixTimestamp) {
      const now = new Date();
      const targetDate = new Date(unixTimestamp * 1);

      // Różnica w milisekundach
      let difference = targetDate - now;

      // Obliczanie liczby dni, godzin i minut
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      difference -= days * (1000 * 60 * 60 * 24);

      const hours = Math.floor(difference / (1000 * 60 * 60));
      difference -= hours * (1000 * 60 * 60);

      const minutes = Math.floor(difference / (1000 * 60));
      if (days >= 0) {
        return `${days} dni ${hours}h  ${minutes}m do zakończenia`;
      } else {
        return `Zakończona`;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .car_list_item {
  display: flex;
  padding: 10px;
  margin: auto;
  height: fit-content;
  flex-direction: column;
  background-color: rgb(232, 232, 232);
  margin-bottom: 30px;
  padding-bottom: 40px;
}

.image_box {
  display: inline-block;
  margin-left: 20px;
}

.info_box {
  margin-left: 20px;
}

.auction_name {
  position: relative;
  bottom: 15px;
  font-size: 12px;
}

.image_box img {
  width: 100%;
  height: auto;
}
.info_details span {
  margin-right: 10px;
}
a {
  text-decoration: none;
  color: #249af3;
  cursor: pointer;
}
@media only screen and (min-width: 800px) {
  .car_list_item {
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 20px;
  }
  .image_box img {
    width: 90%;
    max-width: 320px;
    height: auto;
  }
  .image_box {
    display: inline-block;
    margin-left: 20px;
  }
} */
.car_list_item {
  background: #fff;
  display: flex;
  padding: 18px 19px 20px;
  margin: auto;
  gap: 30px;
  height: fit-content;
  cursor: pointer;
  margin-bottom: 30px;
}
.car_list_item .image_box {
  flex-shrink: 0;
  margin: 0;
  width: 289px;
  aspect-ratio: 1;
  background: #fff;
}

.car_list_item .image_box img {
  width: 100%;
  min-width: auto;
  height: 100%;
  object-fit: cover;
}
.info-boxes {
  display: flex;
  gap: 7px;
}
.info-details {
  margin-top: 20px;
  display: grid;
  flex-shrink: 0;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  width: 350px;
}
.info-box {
  padding: 8px;
  font-size: 14px;
  width: 100%;
  font-weight: bold;
  color: #011f68;
  background: #eff2f7;
  margin-left: 0;
}
.info-boxes .info-box {
  width: auto;
  flex-wrap: wrap;
}
.offer {
  padding: 5px;

  font-size: 13px;
  font-weight: bold;
  color: #eff2f7;
  background: #011f68;
}
.auction-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: auto;
  margin-bottom: 0px;
}
.flex {
  display: flex;
  align-items: center;
  gap: 10px;
}
.vin {
  color: #011f68;
  font-weight: 100;
  font-size: 13px;
}
.car_list_item .info_box .first_row a h2 {
  margin: 0;
  font-family: "bicyclette";
  font-size: 22px;
  font-weight: 700;
  line-height: 31.2px;

  color: #011f68;
}

.car_list_item .info_box .first_row .auction_name {
  display: inline-block;
  font-family: "bicyclette";
  font-size: 11px;
  color: white;
  background-color: #be1e2d;
  margin: 0;
  bottom: 0;
  padding: 2px 3px;
}

/* br, hr elems to remove */

.car_list_item .info_box .info-details span strong {
  font-family: "bicyclette";
  font-weight: 700;
  line-height: 19.5px;
  color: #011f68;
}
.car_list_item .info_box .info-details span {
  margin-right: 0;
  font-family: "bicyclette";
  font-size: 15px;
  font-weight: 400;
  line-height: 19.5px;
  color: #828a9d;
}
.car_list_item .info_box .info_price {
  font-family: "bicyclette";
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
  color: #011f68;
}
.car_list_item .info_box .info_price span {
  color: #be1e2d;
  font-weight: 700;
  font-size: 22px;
}

.time_until {
  display: inline-block;
  font-size: 13px;
  color: #828a9d;
  display: flex;
  gap: 5px;
  font-weight: bold;
  align-content: center;
  margin-top: 0;
}
.date {
  display: inline-block;
  font-size: 13px;
  color: #011f68;
  display: flex;
  gap: 5px;
  font-weight: bold;
  align-content: center;
}
@media only screen and (max-width: 799px) {
  .car_list_item .image_box {
    width: 100%;
  }
}

@media only screen and (min-width: 800px) {
  .car_list_item .image_box {
    margin: 0;
  }

  .image_box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
@media only screen and (max-width: 799px) {
  .car_list_item {
    flex-direction: column;
  }
  .image_box {
    height: 300px;
    width: 100px;
  }
  .image_box img {
    width: 100% !important;
  }
  .info-details {
    width: 200px;
  }
  .offer {
    width: 50%;
  }
}
</style>
